import { useEffect, useState } from "react"
import PullToRefresh from "react-simple-pull-to-refresh"

import { LoadingSpinner } from "@/components/shared"
import { AffiliateProductDetails } from "@/features/jobs/affiliates/components/affiliate-product"
import { AffiliateCampaignDetail } from "@/features/jobs/explore/components/campaign"
import { safeJsonParse } from "@/modules/helpers/utils/safe-json"
import { AffiliateCampaign } from "@/modules/types"

const AffiliatePreviewDetails = () => {
  const [data, setData] = useState<AffiliateCampaign>()
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const parsedData = safeJsonParse<{ type: string; data: AffiliateCampaign }>(event.data)
      if (!parsedData) return

      if (parsedData.type === "PREVIEW_DATA") {
        setData(parsedData.data)
      }
    }
    window.addEventListener("message", handleMessage)
    return () => window.removeEventListener("message", handleMessage)
  }, [])

  const handleRefresh = async () => {}
  if (!data) {
    return (
      <div className="flex flex-col h-screen max-h-[100dvh] items-center justify-center text-black">
        <LoadingSpinner className="w-32 h-32" />
      </div>
    )
  }

  return (
    <div className="flex flex-col h-full">
      {/* <ScreenHeader title="Chi tiết chiến dịch" backUrl="/explore" hiddenBackButton /> */}
      {/* Content */}
      <PullToRefresh
        onRefresh={handleRefresh}
        pullingContent=""
        refreshingContent={<LoadingSpinner className="w-20 h-20" />}
        maxPullDownDistance={80}
      >
        <div className="flex-1 flex flex-col">
          <AffiliateCampaignDetail data={data} layoutBanner="upper" />
          <div className="px-4 pb-8 bg-background pt-4 rounded-t-3xl">
            <AffiliateProductDetails
              id={data?.products?.id}
              layoutBanner="upper"
              isShowAction={false}
              data={data?.products}
              preload={true}
            />
          </div>
        </div>
      </PullToRefresh>
      {/* <ApplyCampaignForm data={data} refetch={refetch} /> */}
    </div>
  )
}

export default AffiliatePreviewDetails
